import axiosOriginal from 'axios'
import { serialize, showMessage } from '@/utils'
import NProgress from 'nprogress' // progress bar
import errorCode from '@/const/errorCode'

import { ElMessageBox } from 'element-plus'
import 'nprogress/nprogress.css'
// import qs from 'qs'
import { useUserStore } from '@/stores/user.js'

let clientIp = '192.168.6.6'
axiosOriginal.get('https://ipinfo.io/json').then(res => {
  if (res.data && res.data.ip) clientIp = res.data.ip
})

const axios = axiosOriginal.create({ timeout: 30000, baseURL: import.meta.env.VITE_API_URL })
const userStore = useUserStore()
// 返回其他状态吗
axios.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
// axios.defaults.withCredentials = true
// NProgress Configuration
NProgress.configure({
  showSpinner: false
})

// HTTPrequest拦截
axios.interceptors.request.use(
  config => {
    NProgress.start() // start progress bar
    const disableToken = (config.headers || {}).isToken === false
    const token = userStore.access_token

    if (token && !disableToken) {
      config.headers['Authorization'] = 'Bearer ' + token // token
    }
    const tenantId = userStore.tenantId

    if (tenantId) {
      config.headers['TENANT-ID'] = tenantId // 租户ID
    }
    config.headers['USER-IP'] = clientIp
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && config.headers.serialize) {
      config.data = serialize(config.data)
      delete config.data.serialize
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// HTTPresponse拦截
axios.interceptors.response.use(
  res => {
    NProgress.done()
    const finalRes = res.data ? res.data : res
    if (finalRes.code === 0 || !finalRes.msg) {
      return finalRes
    }
    showMessage({
      message: finalRes.msg,
      type: 'error'
    })
    return Promise.reject(finalRes)
  },
  ({ message, response }) => {
    NProgress.done()
    const status = Number(response?.status || 500)
    const msg = response.data?.msg || errorCode[status] || message || errorCode['default']
    // 后台定义 424 针对令牌过去的特殊响应码
    if (status === 424) {
      ElMessageBox.alert('令牌状态已过期，请点击重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
        const userStore = useUserStore()
        userStore.logout().then(() => {
          // 刷新登录页面，避免多次弹框
          window.location = '/login'
        })
      })
      return
    }

    // 针对部署系统时使用的token过期的情况
    if (status === 417) {
      ElMessageBox.confirm('系统令牌状态已过期，请点击更新系统令牌', '系统提示', {
        confirmButtonText: '更新系统令牌',
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        window.open('/#/refresh-token', '_blank')
      })
      return
    }

    // 处理 503 网络异常
    if (status === 503 && message.includes('No instance available for')) {
      const msg503 = '微服务未启动，请联系管理员。'
      showMessage({
        message: msg503,
        type: 'error'
      })
    }

    showMessage({
      message: msg,
      type: 'error'
    })
    return Promise.reject(response)
  }
)

export default axios
